import styled from "styled-components";

export const DeliveryAddressMapModalWrapper = styled.div`
  &.delivery-map-modal {
    width: min(720px, 90vw);
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    padding: 1.5rem;
    padding-top: 2.5rem;
    overflow-y: auto;
  }

  .map-modal-title {
    margin: 0 0 0.25rem;
    font-size: 1.125rem;
    font-weight: 600;
    color: #24272e;
  }

  .map-modal-hint {
    margin: 0 0 1rem;
    font-size: 0.8125rem;
    color: #6b7280;
  }

  .map-modal-address-field {
    margin-bottom: 1rem;
    flex-shrink: 0;
  }

  .map-container-wrapper {
    position: relative;
    flex: 1;
    min-height: 320px;
    max-height: 400px;
    border-radius: 0.5rem;
    overflow: hidden;
    border: 1px solid #e0e2e6;
  }

  .map-container {
    width: 100%;
    height: 100%;
    min-height: 320px;
  }

  .map-center-pin {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -100%);
    pointer-events: none;
    z-index: 2;
    font-size: 2rem;
    line-height: 1;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.25));
  }

  .map-loading-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.85);
    color: #6b7280;
    font-size: 0.875rem;
    z-index: 1;
  }

  .map-modal-actions {
    margin-top: 1rem;
    flex-shrink: 0;
  }

  .resolved-address {
    margin: 0.75rem 0 0;
    font-size: 0.8125rem;
    color: #24272e;
    line-height: 1.4;
  }
`;
